import { render, staticRenderFns } from "./ExpectEmail.vue?vue&type=template&id=7c1b0e6a&"
import script from "./ExpectEmail.vue?vue&type=script&lang=js&"
export * from "./ExpectEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports